import React, { useMemo } from 'react';
import { ListItemProps, ListProps } from '@mui/material';
import { PatientFutureSupportMeeting } from 'services/support-meetings';
import { useSourceSupportMeetingTypes } from '../../../hooks';
import { MeetingList, MeetingItem } from '../../../meetings-list';

export interface ListItemMeetingProps extends Pick<ListItemProps, 'disableGutters'> {}

interface Props extends Omit<ListProps, 'onSelect' | 'onChange'> {
  selectedID: string | null;
  onSelect: (selectedID: null | string) => void;
  list: PatientFutureSupportMeeting[];
  ItemsProps?: Partial<ListItemMeetingProps>;
  disabled: boolean;
}
export const ListFutureSupportMeetings: React.FC<React.PropsWithChildren<Props>> = ({
  list,
  selectedID,
  disabled,
  onSelect,
  ...rest
}) => {
  const { map: typeMap } = useSourceSupportMeetingTypes();
  const meetingsList = useMemo<Array<MeetingItem>>(
    () =>
      list.map((meeting) => {
        return {
          ...meeting,
          type: typeMap[meeting.supportMeetingTypeID],
          employee: { fullName: meeting.employee },
        };
      }),
    [list, typeMap],
  );

  return (
    <MeetingList
      value={selectedID}
      onChange={onSelect}
      options={meetingsList}
      disabled={disabled}
      {...rest}
    />
  );
};
